import { UserRoles } from "../core/global";
import { ApiResponse, err, getAxios, postAxios, processError, res } from "./axios";

export const getOrganisationUsers = async ({
  id
}: {
  id: number | string | null | undefined
}):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/org/get-organisation-users/${id ? `${id}` : `` }`, false)

    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error getting organisation users.")
    return err(message, status)
  }
}

export const getOrganisationDetails = async ({
  id
}: {
  id: number | string | null | undefined
}):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/auth/get-organisation-users/${id ? `${id}` : `` }`, false)

    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error getting organisation users.")
    return err(message, status)
  }
}


export const deleteOrganisationUser = async ({
  id
}: {
  id: number | string | null | undefined
}):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/org/delete-organisation-user/${id ? `${id}` : `` }`, false)

    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error deleting organisation users.")
    return err(message, status)
  }

}

export interface UpdateOrganisationUserRole {
  // user_id: number | string | null | undefined   // user id that this is requested for
  role?: UserRoles | null | undefined
  organisation_id: number | string | null |undefined      // company for which change is requested
  email?: string | null | undefined
}

export const updateOrganisationUserRole = async ({...params}: UpdateOrganisationUserRole):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/org/update-organisation-user-role`, {...params}, false)

    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error editing organisation users.")
    return err(message, status)
  }

}


export const getUserOrganisations = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/org/get-user-organisations`, false)

    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error getting user organisation details.")
    return err(message, status)
  }

}


interface UpdateOrganisationProps {
  id?: string | number | null
  name?: string | null
  vat_number?: string | null
  last_modified?: string[] | null
  address?: string | null
  address_2?: string | null
  address_3?: string | null
  city?: string | null
  postcode?: string | null
  country?: string | null
  vat_exempt?: boolean | null
}

export const updateOrganisation = async ({...params}: UpdateOrganisationProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/org/update-organisation`, {...params}, false)

    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error updating or creating organisation.")
    return err(message, status)
  }

}

export const leaveOrganisation = async ({organisation_id}: { organisation_id: number | string }):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/org/leave-organisation`, {
      organisation_id,
    }, false)

    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error leaving organisation.")
    return err(message, status)
  }
}
